import React, { createContext, useContext, useState } from 'react';

type TraineeData = {
  traineeData: any; // Replace 'any' with a more specific type according to your trainee data structure
  setTraineeData: React.Dispatch<React.SetStateAction<any>>; // Replace 'any' with the specific type
};

export const TraineeDataContext = createContext<TraineeData>({
  traineeData: null,
  setTraineeData: () => {},
});

type TraineeDataProviderProps = {
  children: React.ReactNode;
};

export const TraineeDataProvider = ({ children }: TraineeDataProviderProps) => {
  const [traineeData, setTraineeData] = useState<any>(null); // Replace 'any' with the specific type

  return (
    <TraineeDataContext.Provider value={{ traineeData, setTraineeData }}>
      {children}
    </TraineeDataContext.Provider>
  );
};

export const useTraineeData = () => useContext(TraineeDataContext);
